'use client'

import React from 'react'
import { ToastProvider } from '@/components/ui/toast'
import { Toaster } from '@/components/ui/toaster'
import { QueryProvider } from '@/providers/query/query-provider'
import { WebSocketProvider } from '@/context/websocket-context/WebSocketContext'
import { CreditsProvider } from '@/context/credits-context/Credits-context'
import { CookieConsentProvider } from '@/context/cookie-consent-context/CookieConsentContext'
import { ChatbotProvider } from '@/context/chatbot-context/chatbotContext'
import ChatbotWrapper from '@/components/shared/chatbox/ChatbotWrapper'
import UrlChecker from '@/components/shared/UrlChecker'
import OAuthUserSetup from '@/components/shared/OAuthUserSetup'
import { CookieConsentWrapper } from '@/components/cookie-consent'
import { SubscriptionProvider } from '@/context/subscription-context/SubscriptionContext'
import { initConsoleBridge } from '@/lib/client/console-bridge'

export default function ClientLayout({
  children
}: {
  children: React.ReactNode
}) {
  React.useEffect(() => {
    initConsoleBridge()
  }, [])

  return (
    <SubscriptionProvider>
      <ToastProvider>
        <ChatbotProvider>
          <CookieConsentProvider>
            <QueryProvider>
              <WebSocketProvider>
                <CreditsProvider>
                  {children}
                  <ChatbotWrapper />
                  <UrlChecker />
                  <OAuthUserSetup />
                  <CookieConsentWrapper />
                </CreditsProvider>
              </WebSocketProvider>
            </QueryProvider>
          </CookieConsentProvider>
        </ChatbotProvider>
        <Toaster />
      </ToastProvider>
    </SubscriptionProvider>
  )
}